import { AskTigerSparkle } from "./AskTigerSparkle";
import { typingIndicatorStyles as s } from "./TypingIndicator.styles";
import type { TypingIndicatorProps } from "./TypingIndicator.types";

export function TypingIndicator({ label = "Agent is thinking" }: TypingIndicatorProps) {
  return (
    <div className={s.root}>
      <AskTigerSparkle size={14} className={s.sparkle} />
      <span className={s.label}>{label}</span>
    </div>
  );
}
